import { render, staticRenderFns } from "./ProductRate.vue?vue&type=template&id=6ae00db7"
import script from "./ProductRate.vue?vue&type=script&lang=ts"
export * from "./ProductRate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports